import {createAsyncThunk, createReducer} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';

import {ENDPOINTS} from 'constants/endpoints';

import {apiConfig} from 'libs/api/api';

export const initialState = {
    couponCode: '',
    isLoading: false,
};

export const generateOneTimeCoupon = createAsyncThunk<
    AxiosResponse<{
        couponCode: string;
    }>,
    {
        orderId: string;
    }
>('SUCCESS_PAGE@GENERATE_ONE_TIME_COUPON', ({orderId}) =>
    apiConfig.instanceGusaBackend({
        method: 'post',
        url: ENDPOINTS.GENERATE_ONE_TIME_COUPON({orderId}),
    }),
);

/**
 * Reducer active upsell
 * @param {UpsellType} state - Reducer state
 * @return {UpsellType} New reducer state
 */
export const oneTimeCoupon = createReducer<typeof initialState>(initialState, builder => {
    builder.addCase(generateOneTimeCoupon.pending, state => ({
        ...state,
        isLoading: true,
    }));
    builder.addCase(generateOneTimeCoupon.fulfilled, (state, action) => ({
        ...state,
        couponCode: action.payload.data?.couponCode || '',
        isLoading: false,
    }));
    builder.addCase(generateOneTimeCoupon.rejected, state => ({
        ...state,
        isLoading: false,
    }));
});
